export default "__VITE_ASSET__NmtniIBm__"